import React, { Component } from "react";
import Dropzone from "./dropzone/Dropzone";
import csv from 'csv';

import "./Upload.scss";

export default class Upload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            files: [],
            uploading: false,
            uploadProgress: {},
            successfullUploaded: false
        };

        this.onFilesAdded = this.onFilesAdded.bind(this);
    }

    onFilesAdded(files) {
        if (files.length) {
            const reader = new FileReader();

            reader.onload = () => {
                if (files[0].type === 'text/csv') {
                    csv.parse(reader.result, (err, data) => {
                        if (data.length) {
                            this.props.fileAdded(data);
                        }
                    });
                } else {
                    alert('Wrong file format uploaded');
                }
            };
            reader.readAsBinaryString(files[0]);
        }
    }

    render() {
        return (
            <div className="Upload">
                <div className="Content">
                    <Dropzone onFilesAdded={this.onFilesAdded} />
                </div>
            </div>
        );
    }
}
